import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import { wtsApi } from 'src/api';
export var CompensationProductsActions;
(function (CompensationProductsActions) {
    CompensationProductsActions["GET_COMPENSATION_PRODUCTS_LIST_REQUEST"] = "GET_COMPENSATION_PRODUCTS_LIST_REQUEST";
    CompensationProductsActions["GET_COMPENSATION_PRODUCTS_LIST_SUCCESS"] = "GET_COMPENSATION_PRODUCTS_LIST_SUCCESS";
    CompensationProductsActions["GET_COMPENSATION_PRODUCTS_LIST_FAIL"] = "GET_COMPENSATION_PRODUCTS_LIST_FAIL";
    CompensationProductsActions["POST_COMPENSATION_PRODUCT_REQUEST"] = "POST_COMPENSATION_PRODUCT_REQUEST";
    CompensationProductsActions["POST_COMPENSATION_PRODUCT_SUCCESS"] = "POST_COMPENSATION_PRODUCT_SUCCESS";
    CompensationProductsActions["POST_COMPENSATION_PRODUCT_FAIL"] = "POST_COMPENSATION_PRODUCT_FAIL";
    CompensationProductsActions["PUT_COMPENSATION_PRODUCT_REQUEST"] = "PUT_COMPENSATION_PRODUCT_REQUEST";
    CompensationProductsActions["PUT_COMPENSATION_PRODUCT_SUCCESS"] = "PUT_COMPENSATION_PRODUCT_SUCCESS";
    CompensationProductsActions["PUT_COMPENSATION_PRODUCT_FAIL"] = "PUT_COMPENSATION_PRODUCT_FAIL";
    CompensationProductsActions["DELETE_COMPENSATION_PRODUCT_REQUEST"] = "DELETE_COMPENSATION_PRODUCT_REQUEST";
    CompensationProductsActions["DELETE_COMPENSATION_PRODUCT_SUCCESS"] = "DELETE_COMPENSATION_PRODUCT_SUCCESS";
    CompensationProductsActions["DELETE_COMPENSATION_PRODUCT_FAIL"] = "DELETE_COMPENSATION_PRODUCT_FAIL";
})(CompensationProductsActions || (CompensationProductsActions = {}));
export function getCompensationProductsListRequest() {
    return { type: CompensationProductsActions.GET_COMPENSATION_PRODUCTS_LIST_REQUEST };
}
export function getCompensationProductsListSuccess(compensationProducts) {
    return { type: CompensationProductsActions.GET_COMPENSATION_PRODUCTS_LIST_SUCCESS, payload: compensationProducts };
}
export function getCompensationProductsListFail() {
    return { type: CompensationProductsActions.GET_COMPENSATION_PRODUCTS_LIST_FAIL };
}
export function postCompensationProductRequest() {
    return { type: CompensationProductsActions.POST_COMPENSATION_PRODUCT_REQUEST };
}
export function postCompensationProductSuccess(compensationProduct) {
    return { type: CompensationProductsActions.POST_COMPENSATION_PRODUCT_SUCCESS, payload: compensationProduct };
}
export function postCompensationProductFail() {
    return { type: CompensationProductsActions.POST_COMPENSATION_PRODUCT_FAIL };
}
export function putCompensationProductRequest() {
    return { type: CompensationProductsActions.PUT_COMPENSATION_PRODUCT_REQUEST };
}
export function putCompensationProductSuccess(compensationProduct) {
    return { type: CompensationProductsActions.PUT_COMPENSATION_PRODUCT_SUCCESS, payload: compensationProduct };
}
export function putCompensationProductFail() {
    return { type: CompensationProductsActions.PUT_COMPENSATION_PRODUCT_FAIL };
}
export function deleteCompensationProductRequest() {
    return { type: CompensationProductsActions.DELETE_COMPENSATION_PRODUCT_REQUEST };
}
export function deleteCompensationProductSuccess(compensationProduct) {
    return { type: CompensationProductsActions.DELETE_COMPENSATION_PRODUCT_SUCCESS, payload: compensationProduct };
}
export function deleteCompensationProductFail() {
    return { type: CompensationProductsActions.DELETE_COMPENSATION_PRODUCT_FAIL };
}
export function getCompensationProductsList(params) {
    return (dispatch) => {
        dispatch(getCompensationProductsListRequest());
        return wtsApi.v2.productSearchCreate(params)
            .then(({ data }) => {
            const result = data.Data;
            dispatch(getCompensationProductsListSuccess(result));
        })
            .catch((error) => {
            console.error(error);
            dispatch(getCompensationProductsListFail());
            toastrError(error);
        });
    };
}
export async function getCompensationProduct(id) {
    try {
        const { data } = await wtsApi.v2.productGetDetail(id);
        return data.Data;
    }
    catch (e) {
        toastrError(e);
        return null;
    }
}
export function postCompensationProduct(params) {
    return (dispatch) => {
        dispatch(postCompensationProductRequest());
        return wtsApi.v2.productCreateCreate(params)
            .then(({ data }) => {
            const result = data.Data;
            toastrSuccess();
            dispatch(postCompensationProductSuccess(result));
            return result;
        })
            .catch((error) => {
            console.error(error);
            dispatch(postCompensationProductFail());
            toastrError(error);
        });
    };
}
export function putCompensationProduct(params) {
    return (dispatch) => {
        dispatch(putCompensationProductRequest());
        return wtsApi.v2.productUpdateCreate(params)
            .then(({ data }) => {
            const result = data.Data;
            toastrSuccess();
            dispatch(putCompensationProductSuccess(result));
        })
            .catch((error) => {
            console.error(error);
            dispatch(putCompensationProductFail());
            toastrError(error);
        });
    };
}
export function deleteCompensationProduct(params) {
    return (dispatch) => {
        dispatch(deleteCompensationProductRequest());
        return wtsApi.v2.productDeleteDelete(params)
            .then(() => {
            toastrSuccess();
            dispatch(deleteCompensationProductSuccess(params));
        })
            .catch((error) => {
            console.error(error);
            dispatch(deleteCompensationProductFail());
            toastrError(error);
        });
    };
}
